import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

//helpers:
import {useTranslation} from "react-i18next";
import {isSupportedLanguage} from "../../../../i18n/index";

//components:
import {Dropdown} from "react-bootstrap";
import FontDownloadIcon from "@material-ui/icons/FontDownloadRounded";

//actions:
import {CustomTooltip} from "../../../widgets";
import {mediaItemPageActions} from "../../../redux/MediaItemPage/mediaItemRedux";
import {selectTextFileUrl} from "../../../redux_slices/videoPageSlice";
import {selectCaptionsFileUrl} from "../../../redux_slices/videoPageSlice";

const TranscriptsDropdown = ({itemId, title}) => {
    const {t, i18n} = useTranslation();
    const getCurrentLanguage = () => {
        const detectedLang = i18n?.languages?.[0];
        const shortLang = detectedLang.slice(0, 2);
        const isSupported = isSupportedLanguage(shortLang);

        return isSupported ? detectedLang : "en-US";
    };
    const language = getCurrentLanguage();

    useEffect(() => {
        if (itemId) {
            dispatch(mediaItemPageActions.getTextFileUrl(itemId, language || "en-US"));
            dispatch(mediaItemPageActions.getCaptionsFileUrl(itemId, language || "en-US"));
        }
    }, [itemId]);

    const textFileUrl = useSelector(selectTextFileUrl);
    const captionsFileUrl = useSelector(selectCaptionsFileUrl);

    //redux:
    //actions:
    const dispatch = useDispatch();
    const handleDownloadText = () => {
        const pathableTitle = convertPathable(title);
        const fileName = `${pathableTitle}_text_${language}.txt`;
        return handleDownload(textFileUrl, fileName);
    };

    const handleDownloadCaptions = () => {
        const pathableTitle = convertPathable(title);
        const fileName = `${pathableTitle}_captions_${language}.vtt`;
        return handleDownload(captionsFileUrl, fileName);
    };

    const handleDownload = (fileUrl, fileName) => {
        if (fileUrl?.length) {
            if (!fileName) fileName = fileUrl.split("/").pop();
            fetch(fileUrl).then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = fileName;
                    a.click();
                });
            });
        }
    };

    const convertPathable = s => {
        if ((s.match(/\..{1,4}/g) || []).length > 1) {
            s = s.replace(/\.[^/.]+$/, "");
        }
        s = s.replaceAll(/[ ;,-?#~%/]/g, "_");
        while ((s.match(/\./g) || []).length > 1) {
            s = s.replace(".", "_");
        }
        while ((s.match(/__/) || []).length > 0) {
            s = s.replaceAll("__", "_");
        }
        return s;
    };

    return (
        <CustomTooltip
            config={{
                text: t("HEADER.DROPDOWN_MENU.DOWNLOAD_TRANSCRIPT"),
                placement: "top",
            }}
        >
            <Dropdown className="d-flex">
                <Dropdown.Toggle className="btn btn-light my-auto h-100 w-100">
                    <FontDownloadIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu className="header_menu_list">
                    {textFileUrl ? (
                        <span className="dropdown-item elipsis_1line" onClick={handleDownloadText} active={0}>
                            {t("VIDEOPAGE.DROPDOWN_ITEM.TEXT")}
                        </span>
                    ) : null}
                    {captionsFileUrl ? (
                        <span className="dropdown-item elipsis_1line" onClick={handleDownloadCaptions} active={0}>
                            {t("VIDEOPAGE.DROPDOWN_ITEM.CAPTIONS")}
                        </span>
                    ) : null}
                    {!textFileUrl && !captionsFileUrl ? (
                        <span className="dropdown-item elipsis_1line" active={0}>
                            {t("VIDEOPAGE.DROPDOWN_ITEM.NO_TRANSCRIPTS")}
                        </span>
                    ) : null}
                </Dropdown.Menu>
            </Dropdown>
        </CustomTooltip>
    );
};

export default TranscriptsDropdown;
